import axios from 'axios';
import { ApolloClient } from 'apollo-boost';

import {
  MediaApiResponse,
  genericErrorResponse,
  getMediaApiJwt,
  handleMediaAPIException,
  handleMediaAPIResponse,
  mediaApiUrl,
} from './mediaApiUtils';
import { readFileAsDataUrl } from './processImages';

interface UploadPhotoProps {
  apolloClient: ApolloClient<object>;
  file?: any;
  imageUrl?: string;
  setUploadPercent?: (percent: number) => void;
  memberId?: string;
}

async function mediaApiUpload({
  apolloClient,
  file,
  imageUrl,
  setUploadPercent,
  memberId,
}: UploadPhotoProps): Promise<MediaApiResponse> {
  const apiUrl = mediaApiUrl();
  let token;
  try {
    token = await getMediaApiJwt(apolloClient);
  } catch {
    return (genericErrorResponse as unknown) as MediaApiResponse;
  }

  let uploadProps;
  if (imageUrl) {
    uploadProps = { url: imageUrl };
  } else if (file) {
    let dataUrl = file;
    if (typeof dataUrl !== 'string') {
      dataUrl = await readFileAsDataUrl(file);
    }
    dataUrl = dataUrl.match(',') ? dataUrl.split(',')[1] : dataUrl;

    uploadProps = { bytes: dataUrl.toString('base64') };
  }

  try {
    const res = await axios.post<Record<string, unknown>, MediaApiResponse>(
      `${apiUrl}/images`,
      {
        ...uploadProps,
        ownerIds: memberId,
        jwt: token,
        auto_rotate: true,
      },
      {
        onUploadProgress: (progressEvent): void => {
          if (setUploadPercent) {
            const uploadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadPercent(uploadPercent);
          }
        },
      }
    );

    return handleMediaAPIResponse(res);
  } catch (error) {
    return handleMediaAPIException(error as Error);
  }
}

export default mediaApiUpload;
